"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalStateToJSON = exports.ApprovalStateFromJSONTyped = exports.ApprovalStateFromJSON = exports.ApprovalState = void 0;
/**
 *
 * @export
 */
exports.ApprovalState = {
    PendingApproval: 'PENDING_APPROVAL'
};
function ApprovalStateFromJSON(json) {
    return ApprovalStateFromJSONTyped(json, false);
}
exports.ApprovalStateFromJSON = ApprovalStateFromJSON;
function ApprovalStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ApprovalStateFromJSONTyped = ApprovalStateFromJSONTyped;
function ApprovalStateToJSON(value) {
    return value;
}
exports.ApprovalStateToJSON = ApprovalStateToJSON;
